export const getTraineePositions = (payload?: { page?: number, perPage?: number, tab: string }) => ({
    type: "@saga/GET_TRAINEE_POSITIONS",
    payload
});